import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { PATH } from "@/configuration/globalVariable";
import base64 from "base-64";

const Index = () => {
  const navigate = useNavigate();
  const redirectPath = base64.encode(`/sales/documents/orders`);

  useEffect(() => {
    navigate(`/${PATH.REDIRECT}?path=${redirectPath}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default Index;
